/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ProductInstanceLicense } from '../models/product-instance-license';
@Injectable({
  providedIn: 'root',
})
class LicenseService extends __BaseService {
  static readonly LicenseCreateProductLicensePath = '/api/License/CreateProductLicense';
  static readonly LicenseReplaceProductLicensePath = '/api/License/ReplaceProductLicense';
  static readonly LicenseGetLicensesByProductInstanceIdPath = '/api/License/GetLicensesByProductInstanceId';
  static readonly LicenseGetLicenseByIdPath = '/api/License/GetLicenseById';
  static readonly LicenseUpdateLicensePath = '/api/License/UpdateLicense';
  static readonly LicenseDeleteLicenseByIdPath = '/api/License/DeleteLicenseById';
  static readonly LicenseInsertFilePath = '/api/License/InsertFile';
  static readonly LicenseRetrieveFilePath = '/api/License/RetrieveFile/{licenseId}';
  static readonly LicenseGetFilePath = '/api/License/GetFile/{uri}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `LicenseService.LicenseCreateProductLicenseParams` containing the following parameters:
   *
   * - `model`:
   *
   * - `productInstanceId`:
   */
  LicenseCreateProductLicenseResponse(params: LicenseService.LicenseCreateProductLicenseParams): __Observable<__StrictHttpResponse<ProductInstanceLicense>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.model;
    if (params.productInstanceId != null) __params = __params.set('productInstanceId', params.productInstanceId.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/License/CreateProductLicense`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ProductInstanceLicense>;
      })
    );
  }
  /**
   * @param params The `LicenseService.LicenseCreateProductLicenseParams` containing the following parameters:
   *
   * - `model`:
   *
   * - `productInstanceId`:
   */
  LicenseCreateProductLicense(params: LicenseService.LicenseCreateProductLicenseParams): __Observable<ProductInstanceLicense> {
    return this.LicenseCreateProductLicenseResponse(params).pipe(
      __map(_r => _r.body as ProductInstanceLicense)
    );
  }

  /**
   * @param params The `LicenseService.LicenseReplaceProductLicenseParams` containing the following parameters:
   *
   * - `replacedLicenseId`:
   *
   * - `newPrice`:
   *
   * - `extendByMonths`:
   */
  LicenseReplaceProductLicenseResponse(params: LicenseService.LicenseReplaceProductLicenseParams): __Observable<__StrictHttpResponse<ProductInstanceLicense>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.replacedLicenseId != null) __params = __params.set('replacedLicenseId', params.replacedLicenseId.toString());
    if (params.newPrice != null) __params = __params.set('newPrice', params.newPrice.toString());
    if (params.extendByMonths != null) __params = __params.set('extendByMonths', params.extendByMonths.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/License/ReplaceProductLicense`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ProductInstanceLicense>;
      })
    );
  }
  /**
   * @param params The `LicenseService.LicenseReplaceProductLicenseParams` containing the following parameters:
   *
   * - `replacedLicenseId`:
   *
   * - `newPrice`:
   *
   * - `extendByMonths`:
   */
  LicenseReplaceProductLicense(params: LicenseService.LicenseReplaceProductLicenseParams): __Observable<ProductInstanceLicense> {
    return this.LicenseReplaceProductLicenseResponse(params).pipe(
      __map(_r => _r.body as ProductInstanceLicense)
    );
  }

  /**
   * @param productInstanceId undefined
   */
  LicenseGetLicensesByProductInstanceIdResponse(productInstanceId?: number): __Observable<__StrictHttpResponse<Array<ProductInstanceLicense>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (productInstanceId != null) __params = __params.set('productInstanceId', productInstanceId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/License/GetLicensesByProductInstanceId`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ProductInstanceLicense>>;
      })
    );
  }
  /**
   * @param productInstanceId undefined
   */
  LicenseGetLicensesByProductInstanceId(productInstanceId?: number): __Observable<Array<ProductInstanceLicense>> {
    return this.LicenseGetLicensesByProductInstanceIdResponse(productInstanceId).pipe(
      __map(_r => _r.body as Array<ProductInstanceLicense>)
    );
  }

  /**
   * @param productInstanceLicenseId undefined
   */
  LicenseGetLicenseByIdResponse(productInstanceLicenseId?: number): __Observable<__StrictHttpResponse<ProductInstanceLicense>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (productInstanceLicenseId != null) __params = __params.set('productInstanceLicenseId', productInstanceLicenseId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/License/GetLicenseById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ProductInstanceLicense>;
      })
    );
  }
  /**
   * @param productInstanceLicenseId undefined
   */
  LicenseGetLicenseById(productInstanceLicenseId?: number): __Observable<ProductInstanceLicense> {
    return this.LicenseGetLicenseByIdResponse(productInstanceLicenseId).pipe(
      __map(_r => _r.body as ProductInstanceLicense)
    );
  }

  /**
   * @param model undefined
   */
  LicenseUpdateLicenseResponse(model: ProductInstanceLicense): __Observable<__StrictHttpResponse<ProductInstanceLicense>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/License/UpdateLicense`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ProductInstanceLicense>;
      })
    );
  }
  /**
   * @param model undefined
   */
  LicenseUpdateLicense(model: ProductInstanceLicense): __Observable<ProductInstanceLicense> {
    return this.LicenseUpdateLicenseResponse(model).pipe(
      __map(_r => _r.body as ProductInstanceLicense)
    );
  }

  /**
   * @param productInstanceLicenseId undefined
   */
  LicenseDeleteLicenseByIdResponse(productInstanceLicenseId?: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (productInstanceLicenseId != null) __params = __params.set('productInstanceLicenseId', productInstanceLicenseId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/License/DeleteLicenseById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param productInstanceLicenseId undefined
   */
  LicenseDeleteLicenseById(productInstanceLicenseId?: number): __Observable<Blob> {
    return this.LicenseDeleteLicenseByIdResponse(productInstanceLicenseId).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `LicenseService.LicenseInsertFileParams` containing the following parameters:
   *
   * - `licenseId`:
   *
   * - `asset`:
   */
  LicenseInsertFileResponse(params: LicenseService.LicenseInsertFileParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let __formData = new FormData();
    __body = __formData;
    if (params.licenseId != null) __params = __params.set('licenseId', params.licenseId.toString());
    if (params.asset != null) { __formData.append('asset', params.asset as unknown as string | Blob);}
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/License/InsertFile`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `LicenseService.LicenseInsertFileParams` containing the following parameters:
   *
   * - `licenseId`:
   *
   * - `asset`:
   */
  LicenseInsertFile(params: LicenseService.LicenseInsertFileParams): __Observable<boolean> {
    return this.LicenseInsertFileResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param licenseId undefined
   */
  LicenseRetrieveFileResponse(licenseId: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/License/RetrieveFile/${encodeURIComponent(String(licenseId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param licenseId undefined
   */
  LicenseRetrieveFile(licenseId: number): __Observable<Blob> {
    return this.LicenseRetrieveFileResponse(licenseId).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param uri undefined
   */
  LicenseGetFileResponse(uri: string): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/License/GetFile/${encodeURIComponent(String(uri))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param uri undefined
   */
  LicenseGetFile(uri: string): __Observable<Blob> {
    return this.LicenseGetFileResponse(uri).pipe(
      __map(_r => _r.body as Blob)
    );
  }
}

module LicenseService {

  /**
   * Parameters for LicenseCreateProductLicense
   */
  export interface LicenseCreateProductLicenseParams {
    model: ProductInstanceLicense;
    productInstanceId?: number;
  }

  /**
   * Parameters for LicenseReplaceProductLicense
   */
  export interface LicenseReplaceProductLicenseParams {
    replacedLicenseId?: number;
    newPrice?: number;
    extendByMonths?: number;
  }

  /**
   * Parameters for LicenseInsertFile
   */
  export interface LicenseInsertFileParams {
    licenseId?: number;
    asset?: null | Blob;
  }
}

export { LicenseService }
